module.exports = __webpack_public_path__ + "img/embed-4.4ecd58ce.svg";